module.exports = __webpack_public_path__ + "static/gradientOne-eb4f69a457e6cf55fbd69df74c5a4cde.png";